import { render, staticRenderFns } from "./HkiaraceBannerSetting.vue?vue&type=template&id=2f558fca"
import script from "./HkiaraceBannerSetting.vue?vue&type=script&lang=js"
export * from "./HkiaraceBannerSetting.vue?vue&type=script&lang=js"
import style0 from "./HkiaraceBannerSetting.vue?vue&type=style&index=0&id=2f558fca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports